import axios from "axios";
import {
  GET_VIBE_WHEEL_HISTORY,
  GET_VIBE_WHEEL_STATS,
  GET_VIBE_WHEEL,
  RESET_VIBE_WHEEL_COIN,
} from "./type";
import {
  CLOSE_SPINNER_PROGRESS,
  OPEN_SPINNER_PROGRESS,
} from "../spinner/types";
import { Toast } from "../../util/Toast";

export const getVibeWheelHistory = (page = 1, limit = 20, startDate = null, endDate = null) => (dispatch) => {
  let url = `/vibewheelHistory/admin/history?page=${page}&limit=${limit}`;

  if (startDate && endDate && startDate !== "ALL" && endDate !== "ALL") {
    url += `&startDate=${startDate}&endDate=${endDate}`;
  }

  axios
    .get(url)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: GET_VIBE_WHEEL_HISTORY,
          payload: {
            history: res.data.history,
            pagination: res.data.pagination
          }
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error);
      Toast("error", "Failed to load VibeWheel History");
    });
};

export const getVibeWheelStats = (startDate = null, endDate = null) => (dispatch) => {
  let url = "/vibewheelHistory/admin/stats";

  if (startDate && endDate && startDate !== "ALL" && endDate !== "ALL") {
    url += `?startDate=${startDate}&endDate=${endDate}`;
  }

  axios
    .get(url)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_VIBE_WHEEL_STATS, payload: res.data.stats });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error);
      Toast("error", "Failed to load VibeWheel Stats");
    });
};

export const getVibeWheel = () => (dispatch) => {
  axios
    .get("/vibewheel")
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_VIBE_WHEEL, payload: res.data.vibeWheel });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error);
      Toast("error", "Failed to load VibeWheel data");
    });
};

export const resetVibeWheelCoin = () => (dispatch) => {
  dispatch({ type: OPEN_SPINNER_PROGRESS });
  axios
    .post("/vibewheel/resetAdminCoin")
    .then((res) => {
      dispatch({ type: CLOSE_SPINNER_PROGRESS });
      if (res.data.status) {
        Toast("success", "Admin coin reset successfully!");
        dispatch({ type: RESET_VIBE_WHEEL_COIN, payload: res.data.vibeWheel });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      dispatch({ type: CLOSE_SPINNER_PROGRESS });
      console.log("error", error);
      Toast("error", "Failed to reset admin coin");
    });
};
